import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { IdParam } from '../../models/gen/idParam';
import { OutsourceInvoicePublishParam } from '../../models/gen/outsourceInvoicePublishParam';
import { OutsourceInvoiceSearchIdParam } from '../../models/gen/outsourceInvoiceSearchIdParam';
import { OutsourceInvoiceSearchIdResult } from '../../models/gen/outsourceInvoiceSearchIdResult';
import { useGenericMutation } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const OUTSOURCER_INVOICE_CONTEXT_NAMES = {
  POST_OUTSOURCER_INVOICE_ID: 'searchOutsourceInvoiceId',
  POST_OUTSOURCER_INVOICE_PUBLISH_CONFIRM: 'confirmPublishedOutsourceInvoice',
} as const;

const apis = apiGenerator();

/**
 * POST /outsourcer-invoice/id
 *
 * @param param -
 * @returns
 */
export const usePostOutsourcerInvoiceId = () =>
  useGenericMutation(async (param: OutsourceInvoiceSearchIdParam) =>
    apis.post<OutsourceInvoiceSearchIdParam, OutsourceInvoiceSearchIdResult>(
      `${env.BASE_API_ENDPOINT}/outsourcer-invoice/id`,
      { ...queryOptions, data: param }
    )
  );

/**
 * POST /outsourcer-invoice/publish/confirm
 *
 * @param param -
 * @returns
 */
export const usePostOutsourcerInvoicePublishConfirm = () =>
  useGenericMutation(async (param: IdParam) =>
    apis.post(`${env.BASE_API_ENDPOINT}/outsourcer-invoice/publish/confirm`, {
      ...queryOptions,
      data: param,
    })
  );
